<template>
  <Layout :top-bar-title="title" :sections="sections" :baseLayoutInfoUrl="'/base-layout-info/'">
    <ProductForm/>
  </Layout>
</template>

<script>
import Layout from '@/apps/core/components/Layout'
import sections from '@/apps/dido/views/defaultNavigationDrawerSections'
import ProductForm from '@/apps/titan/components/forms/ProductForm'

export default {
  name: 'ProductDetail',
  components: { Layout, ProductForm },
  data () {
    return {
      sections: sections,
      title: this.$t('general.product')
    }
  }
}
</script>

<style scoped>

</style>
